"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Lexer_token;
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const lexer_1 = __importDefault(require("./grammar/lexer"));
const defaults_1 = __importDefault(require("./defaults"));
const log = (0, debug_1.default)('exchange-parser:lexer');
const logEvaluation = (0, debug_1.default)('exchange-parser-evaluation:inline-lexer');
const isSafari = global.navigator &&
    global.navigator.userAgent &&
    /^((?!chrome|android).)*safari/i.test(global.navigator.userAgent);
const headingRegExp = [1, 2, 3, 4, 5, 6].map((heading) => new RegExp(`^ *\\<[Hh](${heading})(?: [\\s\\S]*?)?\\>([\\s\\S]+?)\\</[hH]${heading}(?: [\\s\\S]*)?\\>`));
function testHeadingTag(src) {
    return headingRegExp
        .map((regExp) => regExp.exec(src))
        .find((result) => result);
}
function splitByPipes(src) {
    if (isSafari) {
        return src.split(/ *\| */);
    }
    /**
     * Disabling the rule 'prefer-regex-literals' combined with
     * the use of RegExp constructor is used here to avoid errors
     * with browsers that do not support lookbehind.
     */
    // eslint-disable-next-line prefer-regex-literals
    return src.split(new RegExp(' *(?<!\\\\)\\| *'));
}
class Lexer {
    constructor(options) {
        // preprocessing
        this.lex = (src) => {
            log('-------------------------------------------------------------------');
            log('                        starting src lexing                        ');
            log('-------------------------------------------------------------------');
            src = src
                .replace(/\r\n|\r/g, '\n')
                .replace(/\t/g, '    ')
                .replace(/\u00a0/g, ' ')
                .replace(/\u2424/g, '\n');
            const result = __classPrivateFieldGet(this, _Lexer_token, "f").call(this, src, true);
            log('result', result);
            return result;
        };
        _Lexer_token.set(this, (src, top, bq, depth = 1) => {
            var _a;
            src = src.replace(/ +$/gm, '');
            let next;
            let cap;
            let item;
            let space;
            while (src) {
                log('Lexing src', src);
                // newline
                logEvaluation('Evaluating newline');
                if ((cap = lexer_1.default.newline.exec(src))) {
                    log('Newline found');
                    src = src.substring(cap[0].length);
                    if (cap[0].length > 1) {
                        this.tokens.push({
                            type: 'space'
                        });
                    }
                }
                // code
                logEvaluation('Evaluating code');
                if ((cap = lexer_1.default.code.exec(src))) {
                    src = src.substring(cap[0].length);
                    const capSrc = cap[0].replace(/^ {4}/gm, '');
                    log('Code found:', capSrc);
                    this.tokens.push({
                        type: 'code',
                        text: !this.options.pedantic ? capSrc.replace(/\n+$/, '') : capSrc
                    });
                    continue;
                }
                // fences (gfm)
                logEvaluation('Evaluating fences');
                if ((cap = lexer_1.default.fences.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Fences found:', cap[2], cap[3]);
                    this.tokens.push({
                        type: 'code',
                        lang: cap[2],
                        text: (_a = cap[3]) !== null && _a !== void 0 ? _a : ''
                    });
                    continue;
                }
                // heading
                logEvaluation('Evaluating heading');
                if ((cap = lexer_1.default.heading.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('Heading found:', cap[1].length, cap[2]);
                    this.tokens.push({
                        type: 'heading',
                        depth: cap[1].length,
                        text: cap[2]
                    });
                    continue;
                }
                // heading tag
                logEvaluation('Evaluating heading tag');
                if ((cap = testHeadingTag(src))) {
                    src = src.substring(cap[0].length);
                    log('Heading tag found:', `h${cap[1]}`, cap[2]);
                    this.tokens.push({
                        type: 'heading',
                        depth: +cap[1],
                        text: cap[2]
                    });
                    continue;
                }
                // table no leading pipe (gfm)
                logEvaluation('Evaluating table no leading pipe');
                if (top && (cap = lexer_1.default.nptable.exec(src))) {
                    src = src.substring(cap[0].length);
                    item = {
                        type: 'table',
                        src: cap[0],
                        header: splitByPipes(cap[1].replace(/^ *| *\| *$/g, '')),
                        align: splitByPipes(cap[2].replace(/^ *|\| *$/g, '')),
                        cells: []
                    };
                    const cells = cap[3].replace(/\n$/, '').split('\n');
                    for (let i = 0; i < item.align.length; i += 1) {
                        if (/^ *-+: *$/.test(item.align[i])) {
                            item.align[i] = 'right';
                        }
                        else if (/^ *:-+: *$/.test(item.align[i])) {
                            item.align[i] = 'center';
                        }
                        else if (/^ *:-+ *$/.test(item.align[i])) {
                            item.align[i] = 'left';
                        }
                        else {
                            item.align[i] = null;
                        }
                    }
                    for (let i = 0; i < cells.length; i += 1) {
                        item.cells[i] = splitByPipes(cells[i]);
                    }
                    log('Table found:', item);
                    this.tokens.push(item);
                    continue;
                }
                // lheading
                logEvaluation('Evaluating lheading');
                if ((cap = lexer_1.default.lheading.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('LHeading found:', cap[1]);
                    this.tokens.push({
                        type: 'heading',
                        depth: cap[2] === '=' ? 1 : 2,
                        text: cap[1]
                    });
                    continue;
                }
                // hr
                logEvaluation('Evaluating hr');
                if ((cap = lexer_1.default.hr.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('hr found');
                    this.tokens.push({
                        type: 'hr'
                    });
                    continue;
                }
                // blockquote
                logEvaluation('Evaluating blockquote');
                if ((cap = lexer_1.default.blockquote.exec(src))) {
                    src = src.substring(cap[0].length);
                    this.tokens.push({
                        type: 'blockquote_start'
                    });
                    const capSrc = cap[6]
                        ? `\n${cap[6]}\n`
                        : cap[0].replace(/^ *> ?/gm, '');
                    log('Blockquote found:', capSrc, top);
                    // Pass `top` to keep the current
                    // "toplevel" state. This is exactly
                    // how markdown.pl works.
                    __classPrivateFieldGet(this, _Lexer_token, "f").call(this, capSrc, top, true);
                    this.tokens.push({
                        type: 'blockquote_end'
                    });
                    continue;
                }
                // list
                logEvaluation('Evaluating list');
                if ((cap = lexer_1.default.list.exec(src))) {
                    src = src.substring(cap[0].length);
                    const bull = cap[2];
                    const ordered = bull.length > 1;
                    log('List found:', ordered);
                    this.tokens.push({
                        type: 'list_start',
                        ordered
                    });
                    // Get each top-level item.
                    const capSrc = cap[0].match(lexer_1.default.item);
                    next = false;
                    for (let i = 0; i < capSrc.length; i += 1) {
                        let srcItem = capSrc[i];
                        // Remove the list item's bullet
                        // so it is seen as the next token.
                        space = srcItem.length;
                        srcItem = srcItem.replace(/^ *([*+-]|\d+\.) +/, '');
                        // Outdent whatever the
                        // list item contains. Hacky.
                        if (srcItem.indexOf('\n ') >= 0) {
                            space -= srcItem.length;
                            srcItem = !this.options.pedantic
                                ? srcItem.replace(new RegExp(`^ {1,${space}}`, 'gm'), '')
                                : srcItem.replace(/^ {1,4}/gm, '');
                        }
                        // Determine whether the next list item belongs here.
                        // Backpedal if it does not belong in this list.
                        if (this.options.smartLists && i !== capSrc.length - 1) {
                            const b = lexer_1.default.bullet.exec(capSrc[i + 1])[0];
                            if (bull !== b && !(bull.length > 1 && b.length > 1)) {
                                src = capSrc.slice(i + 1).join('\n') + src;
                                i = capSrc.length - 1;
                            }
                        }
                        // Determine whether item is loose or not.
                        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
                        // for discount behavior.
                        let loose = next || /\n\n(?!\s*$)/.test(srcItem);
                        if (i !== capSrc.length - 1) {
                            next = srcItem.charAt(srcItem.length - 1) === '\n';
                            if (!loose)
                                loose = next;
                        }
                        this.tokens.push({
                            type: loose ? 'loose_item_start' : 'list_item_start',
                            ordered,
                            depth
                        });
                        log('List item found:', srcItem);
                        // Recurse.
                        __classPrivateFieldGet(this, _Lexer_token, "f").call(this, srcItem, false, bq, depth + 1);
                        this.tokens.push({
                            type: 'list_item_end',
                            ordered
                        });
                    }
                    this.tokens.push({
                        type: 'list_end'
                    });
                    continue;
                }
                // html
                logEvaluation('Evaluating html');
                if ((cap = lexer_1.default.html.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('HTML found:', cap[0]);
                    this.tokens.push({
                        type: 'html',
                        pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                        text: cap[0]
                    });
                    continue;
                }
                // def
                logEvaluation('Evaluating def');
                if (!bq && top && (cap = lexer_1.default.def.exec(src))) {
                    src = src.substring(cap[0].length);
                    log('def found:', cap[2], cap[3]);
                    this.tokens.links[cap[1].toLowerCase()] = {
                        href: cap[2],
                        title: cap[3]
                    };
                    continue;
                }
                // table (gfm)
                logEvaluation('Evaluating table (gfm)');
                if (top && (cap = lexer_1.default.table.exec(src))) {
                    src = src.substring(cap[0].length);
                    item = {
                        type: 'table',
                        src: cap[0],
                        header: splitByPipes(cap[1].replace(/^ *| *\| *$/g, '')),
                        align: splitByPipes(cap[2].replace(/^ *|\| *$/g, '')),
                        cells: []
                    };
                    const cells = cap[3].replace(/(?: *\| *)?\n$/, '').split('\n');
                    for (let i = 0; i < item.align.length; i += 1) {
                        if (/^ *-+: *$/.test(item.align[i])) {
                            item.align[i] = 'right';
                        }
                        else if (/^ *:-+: *$/.test(item.align[i])) {
                            item.align[i] = 'center';
                        }
                        else if (/^ *:-+ *$/.test(item.align[i])) {
                            item.align[i] = 'left';
                        }
                        else {
                            item.align[i] = null;
                        }
                    }
                    for (let i = 0; i < cells.length; i += 1) {
                        item.cells[i] = splitByPipes(cells[i].replace(/^ *\| *| *\| *$/g, ''));
                    }
                    log('Table found:', item);
                    this.tokens.push(item);
                    continue;
                }
                // top-level paragraph
                logEvaluation('Evaluating paragraph');
                if (top && (cap = lexer_1.default.paragraph.exec(src))) {
                    src = src.substring(cap[0].length);
                    const paragraph = cap[1] !== undefined ? cap[1].trim() : cap[2];
                    log('Paragraph found:', paragraph);
                    this.tokens.push({
                        type: 'paragraph',
                        text: paragraph.charAt(paragraph.length - 1) === '\n'
                            ? paragraph.slice(0, -1)
                            : paragraph
                    });
                    continue;
                }
                // text
                logEvaluation('Evaluating text');
                if ((cap = lexer_1.default.text.exec(src))) {
                    // Top-level should never reach here.
                    src = src.substring(cap[0].length);
                    log('Text found', cap[0]);
                    this.tokens.push({
                        type: 'text',
                        text: cap[0]
                    });
                    continue;
                }
                if (src) {
                    throw new Error(`Infinite loop on byte: ${src.charCodeAt(0)}`);
                }
            }
            return this.tokens;
        });
        this.tokens = [];
        this.tokens.links = {};
        this.options = Object.assign(Object.assign({}, defaults_1.default), options);
    }
}
_Lexer_token = new WeakMap();
exports.default = Lexer;
